import axios from "axios";
import { customerOrigin } from "../enums/enum";

const ARK_API_URL = process.env.ARK_API_URL;

export const sendNewsLetterByEmail = async (emailData) => {
  try {
    const resp = await axios.post(`${ARK_API_URL}/customers/newsletter`, {
      ...emailData,
      origin: customerOrigin.newsletter
    });
    return true;
  } catch (error) {
    console.error("Error sending news letter email:", error);
  }
};